export const QR_CATEGORIES = 'QR_CATEGORIES'
export const QR_CATEGORIES_DROPDOWN = 'QR_CATEGORIES_DROPDOWN'
export const MARKER_HUES = 'MARKER_HUES'

export const API_PATH = '/qrcode_categories'
export const API_DROPDOWN_PATH = '/qrcode_categories/dropdown'
